var map = {
	"./img1.png": "d660",
	"./img2.png": "4c65",
	"./img3.png": "a6e0",
	"./img4.png": "731a",
	"./img5.png": "c19f",
	"./img6.png": "2f9a",
	"./imgIcon.png": "0c07"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67a8";